<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">SECTION G: OTHER AGREEMENTS AND POLICIES</p>
                    </div>
                    <ul>
                        <li>
                            <strong>Program Handbook &amp; Catalog Compliance:</strong> Students are expected to read,
                            understand, and comply with all specific provisions outlined in the
                            <em>Continuing Education Program Handbook</em> and the university’s overarching <em>Academic Catalog</em>.
                        </li>
                        <li>
                            <strong>Professional Conduct:</strong> Disruptive behavior, unprofessionalism or failure to
                            follow the code of conduct serves as grounds for immediate termination from the program
                            without a refund.
                        </li>
                        <li>
                            <strong>Official Communication:</strong> All official programmatic communication is conducted
                            through the email provided during the application/registration process. Students are required
                            to check these channels daily.
                        </li>
                        <li>
                            <strong>Certificate Award:</strong> The Mentora College Continuing Education Certificate will be
                            officially conferred within 60 days of successfully completing all academic requirements and
                            satisfying all financial balances due to BAU.
                        </li>
                        <li>
                            <strong>Implied Consent for Media:</strong> You agree that BAU or its representatives may
                            photograph, video, or record you during required workshops and teaching demonstrations for
                            program documentation or marketing. If you do not wish to participate, you must advise the
                            administration in writing prior to or at the time of recording.
                        </li>
                        <li>
                            <strong>Grievance Resolution:</strong> Any program complaints that cannot be resolved directly
                            with the Academic Director or Administrative Assistant through written grievance procedures
                            can be formally filed with the Higher Education Licensure Commission (HELC) at 1050 First
                            Street NE, Washington, DC 20002.
                        </li>
                        <li>
                            <strong>Governing Jurisdiction:</strong> This agreement is governed by the laws and statutes
                            of the District of Columbia. Any litigation stemming from this contract must reside exclusively
                            within the courts of Washington, D.C.
                        </li>
                    </ul>
                </b-col>

                <!-- Checkbox + Button -->
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-ce-g"
                                        v-model="form.status"
                                        name="checkbox-ce-g"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="ml-4"
                                    >
                                    </b-form-checkbox>
                                    I read and confirm that I understand the information in Section G.
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                status: null,
            },
        }
    },
    created() {
        window.scrollTo(0, 0)
    },
    methods: {
        async next() {
            const isValid = await this.$refs.formModalValidate.validate()
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1)
        },
    },
}
</script>
